
    import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
    self.MonacoEnvironment = {
      getWorker(_, _label) {
        return new editorWorker();
      },
    };
  